/**
 * Repubblica sample-box (theme-side, box-as-property model).
 *
 * There are NO separate sample line items. Samples ride on a single hidden
 * "Sample Box" product line (window.rpSampleBox.variantId, $15) as line-item
 * properties, and that line's quantity is ceil(totalUnits / perBox), where
 * totalUnits is the sum of the per-sample quantities:
 *   1-5 units -> box qty 1 ($15), 6-10 -> qty 2 ($30), etc.
 *
 * Per sample, on the box line:
 *   "Sample n"  (visible)  = tile name, plus " x N" when its quantity > 1 —
 *                            this is what shows at checkout / on the order.
 *   "_name n" / "_img n" / "_vid n" / "_qty n" (hidden, leading underscore) —
 *                            clean name, thumbnail, variant id and quantity used
 *                            to render the drawer slots. Hidden props don't show
 *                            at checkout.
 *
 * The box line is rebuilt (remove + re-add) on every change — the only reliable
 * way to edit line-item properties via the AJAX cart API.
 *
 * Client-side, so bypassable; a discount Function is the server-side version.
 */
(function () {
  'use strict';

  var cfg = window.rpSampleBox || {};
  var BOX = String(cfg.variantId || '');
  var PER = parseInt(cfg.perBox, 10) || 5;
  var MAX = parseInt(cfg.maxSamples, 10) || 20;
  var PRICE_CENTS = parseInt(cfg.priceCents, 10) || 1500;
  if (!BOX) return;

  var busy = false;

  function isBox(item) { return item && (String(item.id) === BOX || String(item.variant_id) === BOX); }
  function findBox(cart) { for (var i = 0; i < cart.items.length; i++) if (isBox(cart.items[i])) return cart.items[i]; return null; }

  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); }); }
  function post(url, body) { return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }).then(function (r) { if (!r.ok) throw new Error(url); return r.json(); }); }

  // Read the sample list off the box line's properties: { index, name, img, vid, qty }.
  function readSamples(box) {
    var out = [];
    if (!box || !box.properties) return out;
    Object.keys(box.properties).forEach(function (k) {
      var m = k.match(/^Sample (\d+)$/);
      if (!m) return;
      var n = m[1];
      out.push({
        index: parseInt(n, 10),
        name: box.properties['_name' + n] || box.properties[k],
        img: box.properties['_img' + n] || '',
        vid: String(box.properties['_vid' + n] || ''),
        qty: parseInt(box.properties['_qty' + n], 10) || 1
      });
    });
    out.sort(function (a, b) { return a.index - b.index; });
    return out;
  }

  // Reindex samples 1..N into a properties object for a fresh box line.
  function buildProps(samples) {
    var p = {};
    samples.forEach(function (s, i) {
      var n = i + 1;
      var name = s.name || ('Sample ' + n);
      var qty = (s.qty && s.qty > 1) ? s.qty : 1;
      p['Sample ' + n] = qty > 1 ? (name + ' × ' + qty) : name; // visible at checkout
      p['_name' + n] = name;
      p['_img' + n] = s.img || '';
      p['_vid' + n] = String(s.vid || '');
      p['_qty' + n] = String(qty);
    });
    return p;
  }

  function totalUnits(samples) { return samples.reduce(function (sum, s) { return sum + (s.qty || 1); }, 0); }

  function stateFromCart(cart) {
    var samples = readSamples(findBox(cart));
    var units = totalUnits(samples);
    var boxes = units > 0 ? Math.ceil(units / PER) : 0;
    var activeFill = units > 0 ? units % PER : 0;
    if (units > 0 && activeFill === 0) activeFill = PER;
    return {
      selectedSamples: samples,
      samples: samples,
      totalUnits: units,
      boxCount: boxes,
      activeBoxFill: activeFill,
      totalValue: boxes * PRICE_CENTS,
      totalValueCents: boxes * PRICE_CENTS,
      priceCents: PRICE_CENTS,
      perBox: PER,
      maxSamples: MAX
    };
  }

  function getState() {
    return getCart().then(stateFromCart);
  }

  function dispatchState(state) {
    document.dispatchEvent(new CustomEvent('repubblica:sample_box_changed', { detail: state }));
    return state;
  }

  // Replace the box line so it holds exactly `samples` (remove old, add fresh).
  // Box quantity = ceil(total sample units / perBox).
  function rebuild(box, samples) {
    var chain = Promise.resolve();
    if (box) chain = chain.then(function () { return post('/cart/change.js', { id: box.key, quantity: 0 }); });
    var units = totalUnits(samples);
    if (units > 0) {
      var qty = Math.ceil(units / PER);
      chain = chain.then(function () { return post('/cart/add.js', { id: Number(BOX), quantity: qty, properties: buildProps(samples) }); });
    }
    return chain;
  }

  function updateBadge() {
    return getCart().then(function (cart) {
      document.querySelectorAll('.CartCountBubble__Count').forEach(function (el) {
        el.textContent = cart.item_count;
        var hidden = el.parentElement && el.parentElement.querySelector('span.VisuallyHidden');
        if (hidden) hidden.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
      });
    }).catch(function () {});
  }

  function requestCartRefresh() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      return Promise.resolve();
    }

    return new Promise(function (resolve) {
      var finished = false;
      var timeout = setTimeout(finish, 5000);
      function finish() {
        if (finished) return;
        finished = true;
        clearTimeout(timeout);
        resolve();
      }
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { onComplete: finish }
      }));
    });
  }

  function afterChange(changed) {
    if (!changed) { busy = false; return Promise.resolve(); }
    return Promise.all([updateBadge(), requestCartRefresh()]).then(function () {
      return getState().then(dispatchState).catch(function () { return null; });
    }).then(function () {
      busy = false;
    });
  }

  // Add one sample (deduped by variant id — the qty stepper adjusts duplicates).
  function addSample(sample) {
    if (busy) return Promise.resolve({ ok: false, busy: true });
    if (!sample || !sample.vid) return Promise.resolve({ ok: false });
    busy = true;
    return getCart().then(function (cart) {
      var box = findBox(cart);
      var samples = readSamples(box);
      if (samples.some(function (s) { return s.vid === String(sample.vid); })) { busy = false; return { ok: true, already: true }; }
      if (totalUnits(samples) >= MAX) { busy = false; return { ok: false, max: true }; }
      samples.push({ name: sample.name, img: sample.img, vid: String(sample.vid), qty: 1 });
      return rebuild(box, samples)
        .then(function () { return afterChange(true); })
        .then(function () { return { ok: true }; });
    }).catch(function () { busy = false; return { ok: false, error: true }; });
  }

  // Set the quantity of the sample at property index `n` (0 or less removes it).
  function setSampleQty(n, qty) {
    if (busy) return Promise.resolve(false);
    busy = true;
    n = parseInt(n, 10);
    qty = parseInt(qty, 10);
    return getCart().then(function (cart) {
      var box = findBox(cart);
      var samples = readSamples(box);
      var target = null;
      samples.forEach(function (s) { if (s.index === n) target = s; });
      if (!target) { busy = false; return false; }
      if (isNaN(qty) || qty < 1) {
        samples = samples.filter(function (s) { return s.index !== n; });
      } else {
        var others = totalUnits(samples) - target.qty;
        if (others + qty > MAX) qty = MAX - others; // cap total units
        target.qty = qty < 1 ? 1 : qty;
      }
      return rebuild(box, samples)
        .then(function () { return afterChange(true); })
        .then(function () { return true; });
    }).catch(function () { busy = false; return false; });
  }

  // Remove the sample at property index `n`.
  function removeSample(n) { return setSampleQty(n, 0); }

  // Migrate carts left over from the earlier "sample line + box fee" model (or any
  // stray sample line items) into the box-as-property model. Runs once on load.
  function migrateLegacy() {
    return getCart().then(function (cart) {
      var box = findBox(cart);
      var boxSamples = readSamples(box);
      var legacyLines = cart.items.filter(function (i) {
        return !isBox(i) && i.title && i.title.toLowerCase().indexOf('sample') !== -1;
      });
      var legacyBoxEmpty = box && boxSamples.length === 0;
      if ((legacyLines.length === 0 && !legacyBoxEmpty) || busy) return false;
      busy = true;

      var samples = boxSamples.map(function (s) { return { name: s.name, img: s.img, vid: s.vid, qty: s.qty }; });
      var seen = {};
      samples.forEach(function (s) { seen[s.vid] = true; });
      legacyLines.forEach(function (i) {
        var vid = String(i.variant_id || i.id);
        if (seen[vid]) return;
        seen[vid] = true;
        var name = (i.product_title || i.title || 'Sample').replace(/\s*-?\s*sample\s*$/i, '').trim();
        var img = i.image || (i.featured_image && i.featured_image.url) || '';
        samples.push({ name: name, img: img, vid: vid, qty: i.quantity || 1 });
      });

      var updates = {};
      legacyLines.forEach(function (i) { updates[i.key] = 0; });
      if (box) updates[box.key] = 0;
      return post('/cart/update.js', { updates: updates })
        .then(function () { return rebuild(null, samples); })
        .then(function () { return afterChange(true); })
        .then(function () { return true; })
        .catch(function () { busy = false; return false; });
    }).catch(function () { return false; });
  }

  window.RPSampleBox = {
    addSample: addSample,
    removeSample: removeSample,
    setSampleQty: setSampleQty,
    readSamples: readSamples,
    migrateLegacy: migrateLegacy,
    getState: getState,
    isBox: isBox,
    perBox: PER,
    maxSamples: MAX,
    priceCents: PRICE_CENTS
  };

  window.rpSampleBox.priceCents = PRICE_CENTS;
  window.rpSampleBox.getState = getState;

  // Drawer slot controls (rendered by cart-items-drawer.liquid).
  function runSampleControlAction(control, action) {
    var scope = control.closest('.SampleSlot') || control.closest('.SampleBoxCard') || control;
    var drawer = control.closest('#CartDrawer');
    var loadingState = window.RPCartLoading
      ? window.RPCartLoading.beginScope(scope, drawer)
      : null;

    if (!loadingState) {
      scope.classList.add('RpCartScope--loading');
      scope.setAttribute('aria-busy', 'true');
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
    }

    return action().finally(function () {
      if (loadingState) {
        window.RPCartLoading.end(loadingState);
      } else {
        scope.classList.remove('RpCartScope--loading');
        scope.removeAttribute('aria-busy');
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
      }
    });
  }

  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-sample-qty]');
    if (qtyBtn) {
      e.preventDefault();
      if (!busy) runSampleControlAction(qtyBtn, function () {
        return setSampleQty(qtyBtn.getAttribute('data-sample-qty'), qtyBtn.getAttribute('data-qty-to'));
      });
      return;
    }
    var rm = e.target.closest('[data-sample-remove]');
    if (rm) {
      e.preventDefault();
      if (!busy) runSampleControlAction(rm, function () {
        return removeSample(rm.getAttribute('data-sample-remove'));
      });
    }
  });

  // Clean up any legacy cart on load.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', migrateLegacy);
  } else {
    migrateLegacy();
  }
})();
